import { AutogenLayoutOffice941ScheduleBReport } from "./autogen/AutogenLayoutOffice941ScheduleBReport";

export class Office941ScheduleBReport extends AutogenLayoutOffice941ScheduleBReport {

    onLoad() {
        super.onLoad();

        // Set default: Reverse Voids checked
        this.checkboxReverseVoids.checked = true;

        // Include Settlements defaults to unchecked (no action needed)
    }
}
